export const RISK_GRADES = [
  { value: 'high', label: '상', color: '#b91c1c' },
  { value: 'medium', label: '중', color: '#b46709' },
  { value: 'low', label: '하', color: '#15803d' },
];
export const gradeLabel = value => RISK_GRADES.find(grade => grade.value === value)?.label;
export const hasEvaluationInput = (form, mode = 'score') => mode === 'grade'
  ? Boolean(gradeLabel(form?.risk_grade))
  : Boolean(Number(form?.frequency_id) > 0 && Number(form?.importancy_id) > 0);
